import Portfolio from "./pages/Portfolio";
function App() {
  return (
    <Portfolio></Portfolio>
  );
}

export default App;
